export default __webpack_public_path__ + "static/media/blog02.bfb1c12a.jpg";